import { isIbanValid, checkBancontactCardNumber, isNonNumeric, isCardNumber, validateDate } from './cardUtils.js';

const required = (value) => !!value;
const min = (value, length) => value.trim().length >= Number(length);
const max = (value, length) => value.trim().length <= Number(length);
const iban = (value) => isIbanValid(value);
const bancontact = (value) => checkBancontactCardNumber(value);
const nonNumeric = (value) => isNonNumeric(value);
const cardNumber = (value) => isCardNumber(value);
const expirationDate = (value) => {
    const date = value.split('-');
    return validateDate(date[0], date[1]);
};
const expirationDateBC = (value) => {
    const date = value.split('-');
    if (date[1].length < 4)
        return false;
    return validateDate(date[0], date[1]);
};
const validations = {
    required,
    min,
    max,
    iban,
    bancontact,
    nonNumeric,
    cardNumber,
    expirationDate,
    expirationDateBC,
};

export { validations };
//# sourceMappingURL=formUtils.js.map
